import React from 'react';

// Skeleton for alert category cards
export const AlertCategorySkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="flex items-start justify-between mb-4">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 bg-gray-200 rounded-lg"></div>
        <div className="space-y-2">
          <div className="h-4 bg-gray-300 rounded w-32"></div>
          <div className="h-3 bg-gray-200 rounded w-24"></div>
        </div>
      </div>
      <div className="w-8 h-8 bg-red-100 rounded-full"></div>
    </div>
    <div className="grid grid-cols-2 gap-4 mt-4">
      <div className="space-y-2">
        <div className="h-3 bg-gray-200 rounded w-16"></div>
        <div className="h-6 bg-gray-300 rounded w-12"></div>
      </div>
      <div className="space-y-2">
        <div className="h-3 bg-gray-200 rounded w-16"></div>
        <div className="h-6 bg-gray-300 rounded w-12"></div>
      </div>
    </div>
  </div>
);

// Skeleton for realtime event stream
export const RealtimeEventSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="flex items-center justify-between mb-6">
      <div className="h-6 bg-gray-300 rounded w-48"></div>
      <div className="flex gap-2">
        <div className="h-8 bg-gray-200 rounded w-20"></div>
        <div className="h-8 bg-gray-200 rounded w-20"></div>
      </div>
    </div>
    <div className="space-y-3 max-h-96 overflow-hidden">
      {[1, 2, 3, 4, 5]?.map((i) => (
        <div key={i} className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg">
          <div className="w-2 h-2 bg-gray-300 rounded-full mt-2"></div>
          <div className="flex-1 space-y-2">
            <div className="flex items-center justify-between">
              <div className="h-4 bg-gray-300 rounded w-40"></div>
              <div className="h-3 bg-gray-200 rounded w-16"></div>
            </div>
            <div className="h-3 bg-gray-200 rounded w-3/4"></div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

// Skeleton for threshold config
export const ThresholdConfigSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="h-6 bg-gray-300 rounded w-48 mb-6"></div>
    <div className="space-y-4">
      {[1, 2, 3, 4]?.map((i) => (
        <div key={i} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
          <div className="space-y-2 flex-1">
            <div className="h-4 bg-gray-300 rounded w-40"></div>
            <div className="h-3 bg-gray-200 rounded w-32"></div>
          </div>
          <div className="h-10 bg-gray-200 rounded w-24"></div>
        </div>
      ))}
    </div>
  </div>
);

// Skeleton for correlation analysis
export const CorrelationAnalysisSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="h-6 bg-gray-300 rounded w-56 mb-6"></div>
    <div className="space-y-4">
      <div className="h-64 bg-gray-100 rounded-lg"></div>
      <div className="grid grid-cols-3 gap-4">
        {[1, 2, 3]?.map((i) => (
          <div key={i} className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-24"></div>
            <div className="h-6 bg-gray-300 rounded w-16"></div>
          </div>
        ))}
      </div>
    </div>
  </div>
);